export const serverLink = "https://backend.scesport.com";
// export const serverLink = "http://localhost:5001";
